/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_LabelInputs */

const en_brand_label = /** @type {(inputs: Brand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand`)
};

const lv_brand_label = /** @type {(inputs: Brand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zīmols`)
};

/**
* | output |
* | --- |
* | "Brand" |
*
* @param {Brand_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const brand_label = /** @type {((inputs?: Brand_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_brand_label(inputs)
	return en_brand_label(inputs)
});